import { reportEvent } from './util';
const FLOW_ID_KEY = 'wetv_linux_flowids';
const MAX_FLOW_IDS = 3;

export function getFlowIds() {
  const flowIds = localStorage.getItem(FLOW_ID_KEY) || '';
  return flowIds;
}

export function setFlowId(flowId) {
  if (!flowId) {
    return;
  }
  const existingFlowIds = localStorage.getItem(FLOW_ID_KEY);
  const flowIdsArray = existingFlowIds ? existingFlowIds.split('|') : [];

  if (flowIdsArray.length >= MAX_FLOW_IDS) {
    flowIdsArray.shift(); // 移除最早的flowId
  }
  flowIdsArray.push(flowId); // 将新的flowId添加到末尾

  try {
    localStorage.setItem(FLOW_ID_KEY, flowIdsArray.join('|'));
  } catch (error) {
    reportEvent({
      name: 'localStorageError',
      ext2: {
        errCode: 'flowId set local storage error',
        msg: 'Failed to access localStorage',
        error: error.message,
      },
    });
  }
}

export function clearFlowId() {
  localStorage.removeItem(FLOW_ID_KEY);
}
